import YearBlock from "./YearBlock.js";

export default function YearView({ birthday, expected }) {
  const list = [];
  const currentYearNumber =
    new Date().getFullYear() - new Date(birthday).getFullYear();

  for (let i = 0; i < expected; i++) {
    list.push(
      <YearBlock
        key={i}
        past={i < currentYearNumber ? true : false}
        current={i === currentYearNumber ? true : false}
        future={i > currentYearNumber ? true : false}
      />
    );
  }

  return (
    <div className="grid grid-flow-row grid-cols-10 gap-2 justify-items-center">
      {list}
    </div>
  );
}
